export enum CMS {
  GTM = 'gtm',
  WORDPRESS = 'wordpress',
  SHOPIFY = 'shopify',
  WIX = 'wix',
  MAGENTO = 'magento',
  SQUARESPACE = 'squarespace',
  DRUPAL = 'drupal',
  PRESTASHOP = 'prestashop',
  CLICKFUNNELS = 'clickfunnels',
  WOOCOMMERCE = 'woocommerce',
}

export interface PlatformGuide {
  icon: string;
  url: string;
  title: string;
}

export interface Platform extends PlatformGuide {
  id: CMS;
}
